import React, { useState } from "react"
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-react-intl"
import { getLanguageSwitcherUrlByLocale } from "../../services/intl.service"

const Language = ({ pageContext }) => {
  const [isActive, setActive] = useState("false")

  const handleToggle = () => {
    setActive(!isActive)
    const leftColCont = document.querySelector(".colElements")
    leftColCont.classList.toggle("openLang")
  }
  let isWP = false
  //check if property localeBlog exists in pageContext
  if (pageContext.localeBlog) {
    isWP = true
  }

  const languageRefresh = () => {
    const element = document.querySelector(".langueDE");
    const elementFrom = document.querySelector(".langueDE").getAttribute('data-lang');
    element.classList.remove('inactive');
    window.location.hash = elementFrom;
    window.location.reload(true);
  }

  return (
    <div className={isActive ? null : "open"}>
      <div className="blk-langue" onClick={handleToggle}>
        <IntlContextConsumer>
          {({ languages, language: currentLocale }) =>
            languages.map(language => {
              let url = "/" // Home path by default

              if (pageContext && pageContext.translatedUrls) {
                url = getLanguageSwitcherUrlByLocale(
                  language,
                  pageContext.translatedUrls,
                  isWP
                )
              }
              if (isWP) {
                return (
                  <button
                    key={language}
                    role="button"
                    onClick={() => changeLocale(language, url)}
                    className={
                      pageContext.localeBlog.toLowerCase() === language
                        ? ``
                        : `inactive`
                    }
                  >
                    {language}
                  </button>
                )
              } else {
                return (
                  <button
                    key={language}
                    role="button"
                    onClick={() => changeLocale(language, url)}
                    className={currentLocale === language ? `` : `inactive`}
                  >
                    {language}
                  </button>
                )
              }
            })
          }
        </IntlContextConsumer>
        <button data-lang="googtrans(de)" onClick={languageRefresh} className="inactive langueDE noTranslate">DE</button>
      </div>
    </div>
  )
}

export default Language
